/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Web_LinkInputs */

const en_common_web_link = /** @type {(inputs: Common_Web_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web link`)
};

const es_common_web_link = /** @type {(inputs: Common_Web_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace web`)
};

/**
* | output |
* | --- |
* | "Web link" |
*
* @param {Common_Web_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_web_link = /** @type {((inputs?: Common_Web_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Web_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_web_link(inputs)
	return en_common_web_link(inputs)
});